<div class="captcha-container">
    <div class="row">
        <div class="col-xl-11 col-12 text-center">
            <canvas id="captcahCanvas" width="200" height="50"></canvas>
        </div>
        <div class="col-xl-1 col-12 text-center cpt-margin">
            <a href="javascript:void(0)" class="cpt-btn reload" (click)="createCaptcha()"><i class="fas fa-sync-alt"></i></a>
        </div>
    </div>

</div>
